/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';
import * as firebase from 'firebase/app';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Title from './Title';
import AlertModal from './AlertModal';
import { getExams, getExamLocation } from '../../core/exams';

class ExamsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      exams: [],
      confirmationMessage: '',
    };
    this.onClickResult = this.onClickResult.bind(this);
    this.onModalResult = this.onModalResult.bind(this);
    this.updateExams = this.updateExams.bind(this);
    this.saveId = '';
    this.saveResult = '';
  }

  componentDidMount() {
    this.updateExams();
  }

  onClickResult(event, result, id) {
    event.preventDefault();
    this.setState({
      showModal: true,
      confirmationMessage: `Você tem certeza que deseja confirmar o resultado ${result.toUpperCase()} para ${id}?`,
    });

    this.saveId = id;
    this.saveResult = result;
  }

  onModalResult(result) {
    this.setState({ showModal: false });
    const db = firebase.firestore();

    if (result === 'ok') {
      // Send result
      db.collection('exams').doc(this.saveId).set({
        result: this.saveResult,
      }).then(() => {
        this.updateExams();
      });
    }
    this.saveId = '';
    this.saveResult = '';
  }

  updateExams() {
    getExams().then((exams) => {
      this.setState({
        exams,
      });
    });
  }

  renderResult(exam) {
    const { showModal, confirmationMessage } = this.state;

    if (exam.result) {
      const color = exam.result === 'positive' ? 'secondary' : 'initial';
      return (
        <Typography component="h2" variant="subtitle2" color={color} gutterBottom>
          {exam.result}
        </Typography>
      );
    }

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'row',
      }}
      >
        <Button
          type="submit"
          fullWidth
          variant="outlined"
          color="default"
          size="small"
          onClick={(event) => this.onClickResult(event, 'negative', exam.id)}
        >
          NEGATIVO
        </Button>
        <Button
          type="submit"
          fullWidth
          variant="outlined"
          color="secondary"
          size="medium"
          onClick={(event) => this.onClickResult(event, 'inconclusive', exam.id)}
        >
          INCONCLUSIVO
        </Button>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="secondary"
          size="small"
          onClick={(event) => this.onClickResult(event, 'positive', exam.id)}
        >
          POSITIVO
        </Button>
        <AlertModal
          open={showModal}
          onResult={this.onModalResult}
          title="Você tem certeza?"
          description={confirmationMessage}
        />
      </div>
    );
  }

  render() {
    const { exams } = this.state;
    return (
      <div>
        <Title>Exames</Title>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Tubo de Coleta</TableCell>
              <TableCell>Número de Pacientes</TableCell>
              <TableCell>Coordenadas</TableCell>
              <TableCell>Data</TableCell>
              <TableCell align="center">Resultado</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {exams.map((exam) => {
              const position = getExamLocation(exam.samples);
              return (
                <TableRow key={exam.id}>
                  <TableCell>{exam.id}</TableCell>
                  <TableCell align="center">{exam.samples.length}</TableCell>
                  <TableCell>
                    {position.latitude}
                    ,
                    {' '}
                    {position.longitude}
                  </TableCell>
                  <TableCell>{new Date(exam.collectionDate).toUTCString()}</TableCell>
                  <TableCell align="center">
                    {this.renderResult(exam)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default ExamsList;
